<template>
  <div class="checker-search-options">
    <div class="accordion">
      <div
        class="accordion__header"
        @click.self="toggleAccordion('trademarkAccordionBody')"
      >
        <FormulateInput
          v-model="isTrademarkSearch"
          type="checkbox"
          label="Trademark Search"
          :outer-class="['checker-search-options__outer-checkbox-wrapper']"
          :wrapper-class="['formulate-input-wrapper--checkbox']"
          :element-class="[
            'formulate-input-element--checkbox-small',
            'checker-search-options__checkbox-wrapper',
          ]"
          :label-class="['checker-search-options__open-checkbox-label']"
        />

        <InlineSvg
          @click="toggleAccordion('trademarkAccordionBody')"
          :src="require(`../../assets/svgs/down-arrow-black.svg`)"
          class="accordion__arrow"
        />
      </div>

      <div
        class="accordion__body checker-search-options__accordion-body"
        ref="trademarkAccordionBody"
        style="display: none"
      >
        <div>
          <label class="checker-search-options__checkbox-container">
            <FormulateInput
              v-model="isUKTrademarkSearch"
              type="checkbox"
              label="UNITED KINGDOM"
              :outer-class="['checker-search-options__outer-checkbox-wrapper']"
              :wrapper-class="['formulate-input-wrapper--checkbox']"
              :element-class="[
                'formulate-input-element--checkbox-small',
                'checker-search-options__checkbox-wrapper',
              ]"
              :label-class="[
                'checker-search-options__contained-checkbox-label',
              ]"
            />
          </label>

          <label class="checker-search-options__checkbox-container">
            <FormulateInput
              v-model="isEUTrademarkSearch"
              type="checkbox"
              label="EU"
              :outer-class="['checker-search-options__outer-checkbox-wrapper']"
              :wrapper-class="['formulate-input-wrapper--checkbox']"
              :element-class="[
                'formulate-input-element--checkbox-small',
                'checker-search-options__checkbox-wrapper',
              ]"
              :label-class="[
                'checker-search-options__contained-checkbox-label',
              ]"
            />
          </label>

          <label class="checker-search-options__checkbox-container">
            <FormulateInput
                v-model="isUSTrademarkSearch"
                type="checkbox"
                label="US"
                :outer-class="['checker-search-options__outer-checkbox-wrapper']"
                :wrapper-class="['formulate-input-wrapper--checkbox']"
                :element-class="[
                'formulate-input-element--checkbox-small',
                'checker-search-options__checkbox-wrapper',
              ]"
                :label-class="[
                'checker-search-options__contained-checkbox-label',
              ]"
            />
          </label>
        </div>
      </div>
    </div>

    <div class="accordion">
      <div
        class="accordion__header"
        @click.self="toggleAccordion('socialAccordionBody')"
      >
        <FormulateInput
          v-model="socialMediaSearch"
          type="checkbox"
          label="Social Media Search (Please select from Twitter, Facebook and Instagram)"
          :outer-class="['checker-search-options__outer-checkbox-wrapper']"
          :wrapper-class="['formulate-input-wrapper--checkbox']"
          :element-class="[
            'formulate-input-element--checkbox-small',
            'checker-search-options__checkbox-wrapper',
          ]"
          :label-class="['checker-search-options__open-checkbox-label']"
        />

        <InlineSvg
          @click="toggleAccordion('socialAccordionBody')"
          :src="require(`../../assets/svgs/down-arrow-black.svg`)"
          class="accordion__arrow"
        />
      </div>

      <div
        class="accordion__body checker-search-options__accordion-body"
        ref="socialAccordionBody"
        style="display: none"
      >
        <!-- <div class="accordion__body-row">
            <label class="checker-search-options__checkbox-container">
              <FormulateInput
                v-model="socialMediaUsersSearch"
                type="checkbox"
                label="USERS"
                :outer-class="['checker-search-options__outer-checkbox-wrapper']"
                :wrapper-class="['formulate-input-wrapper--checkbox']"
                :element-class="['formulate-input-element--checkbox-small', 'checker-search-options__checkbox-wrapper']"
                :label-class="['checker-search-options__contained-checkbox-label']"
              />
            </label>
  
            <label class="checker-search-options__checkbox-container">
              <FormulateInput
                v-model="socialMediaMentionsSearch"
                type="checkbox"
                label="MENTIONS"
                :outer-class="['checker-search-options__outer-checkbox-wrapper']"
                :wrapper-class="['formulate-input-wrapper--checkbox']"
                :element-class="['formulate-input-element--checkbox-small', 'checker-search-options__checkbox-wrapper']"
                :label-class="['checker-search-options__contained-checkbox-label']"
              />
            </label>
          </div> -->

        <div class="accordion__body-row">
          <label
            class="checker-search-options__checkbox-container disabled-twitter"
          >
            <FormulateInput
              disabled
              v-model="socialMediaTwitterSearch"
              type="checkbox"
              label="TWITTER"
              :outer-class="['checker-search-options__outer-checkbox-wrapper']"
              :wrapper-class="['formulate-input-wrapper--checkbox']"
              :element-class="[
                'formulate-input-element--checkbox-small',
                'checker-search-options__checkbox-wrapper',
                'disabled',
              ]"
              :label-class="[
                'checker-search-options__contained-checkbox-label',
              ]"
              @click="updateSocialMediaTwitterValue"
            />
          </label>

          <label class="checker-search-options__checkbox-container">
            <FormulateInput
              v-model="socialMediaFacebookSearch"
              type="checkbox"
              label="FACEBOOK"
              :outer-class="['checker-search-options__outer-checkbox-wrapper']"
              :wrapper-class="['formulate-input-wrapper--checkbox']"
              :element-class="[
                'formulate-input-element--checkbox-small',
                'checker-search-options__checkbox-wrapper',
              ]"
              :label-class="[
                'checker-search-options__contained-checkbox-label',
              ]"
              @click="updateSocialMediaFacebookValue"
            />
          </label>

          <label class="checker-search-options__checkbox-container">
            <FormulateInput
              v-model="socialMediaInstagramSearch"
              type="checkbox"
              label="INSTAGRAM"
              :outer-class="['checker-search-options__outer-checkbox-wrapper']"
              :wrapper-class="['formulate-input-wrapper--checkbox']"
              :element-class="[
                'formulate-input-element--checkbox-small',
                'checker-search-options__checkbox-wrapper',
              ]"
              :label-class="[
                'checker-search-options__contained-checkbox-label',
              ]"
              @click="updateSocialMediaInstagramValue"
            />
          </label>
        </div>

        <!-- <p class="checker-search-options__notice">
            <b>Please note:</b> User search is only available for Facebook.
          </p> -->
      </div>
    </div>

    <div class="accordion">
      <div
        class="accordion__header"
        @click.self="toggleAccordion('domainAccordionBody')"
      >
        <FormulateInput
          v-model="domainSearch"
          type="checkbox"
          label="Domain Search"
          :outer-class="['checker-search-options__outer-checkbox-wrapper']"
          :wrapper-class="['formulate-input-wrapper--checkbox']"
          :element-class="[
            'formulate-input-element--checkbox-small',
            'checker-search-options__checkbox-wrapper',
          ]"
          :label-class="['checker-search-options__open-checkbox-label']"
        />

        <InlineSvg
          @click="toggleAccordion('domainAccordionBody')"
          :src="require(`../../assets/svgs/down-arrow-black.svg`)"
          class="accordion__arrow"
        />
      </div>

      <div
        class="accordion__body checker-search-options__accordion-body"
        ref="domainAccordionBody"
        style="display: none"
      >
        <label class="checker-search-options__checkbox-container">
          <FormulateInput
            v-model="domainHypenateSearch"
            type="checkbox"
            label="HYPHENATE"
            :outer-class="['checker-search-options__outer-checkbox-wrapper']"
            :wrapper-class="['formulate-input-wrapper--checkbox']"
            :element-class="[
              'formulate-input-element--checkbox-small',
              'checker-search-options__checkbox-wrapper',
            ]"
          >
            <template #label="{ label, id }">
              <label
                :for="id"
                class="formulate-input-label formulate-input-label--after checker-search-options__contained-checkbox-label"
              >
                {{ label }}
              </label>
              <Tooltip
                class="checker-search-options__checkbox-tooltip"
                :content="'Hyphenate your results'"
              />
            </template>
          </FormulateInput>
        </label>

        <!-- <FormulateInput
            v-model="domainIndustrySearch"
            :options="{
              '': 'Select an option',
              education: 'Education Industry',
              food: 'Food Industry',
              construction: 'Construction Industry',
              commerce: 'Commerce Industry',
            }"
            type="select"
            label="Search Category"
            :outer-class="['checker-search-options__outer-select-wrapper']"
            :wrapper-class="['formulate-input-wrapper--select']"
            :label-class="['formulate-input-label--select-overlay']"
          /> -->
      </div>
    </div>

    <div class="accordion">
      <div class="accordion__header accordion__header--no-body">
        <FormulateInput
          v-model="webSearch"
          type="checkbox"
          label="Web Search"
          :outer-class="['checker-search-options__outer-checkbox-wrapper']"
          :wrapper-class="['formulate-input-wrapper--checkbox']"
          :element-class="[
            'formulate-input-element--checkbox-small',
            'checker-search-options__checkbox-wrapper',
          ]"
          :label-class="['checker-search-options__open-checkbox-label']"
        />
      </div>
    </div>

    <p
      v-if="searchOptionsFormError.error"
      class="formulate-input-error checker-search-options__error-message"
    >
      {{ searchOptionsFormError.text }}
    </p>
  </div>
</template>
<style>
.disabled {
  background-color: #ccc;
  pointer-events: none;
  opacity: 0.6;
}
.disabled-twitter label {
  color: grey !important;
}
</style>

<script>
import $ from "jquery";
import InlineSvg from "vue-inline-svg";
import Tooltip from "@/components/ui/Tooltip";

export default {
  name: "CheckerSearchOptions",
  props: {
    searchOptionsFormError: {
      type: Object,
      required: true,
    },
  },
  components: {
    InlineSvg,
    Tooltip,
  },
  data() {
    return {
      isTrademarkSearch: false,
      isEUTrademarkSearch: false,
      isUSTrademarkSearch: false,
      isUKTrademarkSearch: false,
      socialMediaSearch: false,
      socialMediaUsersSearch: false,
      socialMediaMentionsSearch: false,
      socialMediaTwitterSearch: false,
      socialMediaFacebookSearch: false,
      socialMediaInstagramSearch: false,
      domainSearch: false,
      domainHypenateSearch: false,
      domainIndustrySearch: "",
      webSearch: false,
      isSocialShowResults: false,
    };
  },
  watch: {
    isTrademarkSearch: function (currentValue) {
      if (
          currentValue &&
          !this.isUKTrademarkSearch &&
          !this.isEUTrademarkSearch &&
          !this.isUSTrademarkSearch
      ) {
        this.isUKTrademarkSearch = true;
        this.isEUTrademarkSearch = true;
        this.isUSTrademarkSearch = true;
      } else if (!currentValue) {
        this.isUKTrademarkSearch = false;
        this.isEUTrademarkSearch = false;
        this.isUSTrademarkSearch = false;
      }

      this.$emit("trademark-updated", currentValue);
    },

    isUKTrademarkSearch: function (currentValue) {
      if (currentValue) {
        this.isTrademarkSearch = true;
      } else if (!currentValue && !this.isEUTrademarkSearch && !this.isUSTrademarkSearch) {
        this.isTrademarkSearch = false;
      }

      this.$emit("uk-trademark-updated", currentValue);
    },

    isEUTrademarkSearch: function (currentValue) {
      if (currentValue) {
        this.isTrademarkSearch = true;
      } else if (!currentValue && !this.isUKTrademarkSearch && !this.isUSTrademarkSearch) {
        this.isTrademarkSearch = false;
      }

      this.$emit("eu-trademark-updated", currentValue);
    },

    isUSTrademarkSearch: function (currentValue) {
      if (currentValue) {
        this.isTrademarkSearch = true;
      } else if (!currentValue && !this.isEUTrademarkSearch && !this.isUKTrademarkSearch) {
        this.isTrademarkSearch = false;
      }

      this.$emit("us-trademark-updated", currentValue);
    },

    socialMediaSearch: function (currentValue) {
      // Check if Facebook, Instagram, or Twitter is already clicked
      const facebookInstagramTwitterClicked =
        this.socialMediaFacebookSearch ||
        this.socialMediaInstagramSearch ||
        this.socialMediaTwitterSearch;

      if (currentValue) {
        // Only select all if none of them are already clicked
        if (!facebookInstagramTwitterClicked) {
          this.socialMediaUsersSearch = true;
          this.socialMediaMentionsSearch = true;
          this.socialMediaTwitterSearch = true;
          this.socialMediaFacebookSearch = true;
          this.socialMediaInstagramSearch = true;
        }
      } else {
        // Deselect all
        this.socialMediaUsersSearch = false;
        this.socialMediaMentionsSearch = false;
        this.socialMediaTwitterSearch = false;
        this.socialMediaFacebookSearch = false;
        this.socialMediaInstagramSearch = false;
      }

      // console.log("twitter:", this.socialMediaTwitterSearch);

      // console.log("insta:", this.socialMediaInstagramSearch);
      // console.log("fb:", this.socialMediaFacebookSearch);
      // console.log(this.socialMediaTwitterSearch);

      this.isSocialShowResults = currentValue;
      this.$emit("social-media-updated", currentValue);
      this.$emit("social-media-users-updated", currentValue);
      this.$emit("social-media-mentions-updated", currentValue);
      this.$emit("social-media-twitter-updated", this.socialMediaTwitterSearch);
      this.$emit(
        "social-media-facebook-updated",
        this.socialMediaFacebookSearch
      );
      this.$emit(
        "social-media-instagram-updated",
        this.socialMediaInstagramSearch
      );

      this.$emit("social-media-updated", currentValue);
      this.$emit("is-social-show-results-updated", currentValue);
      this.$emit("social-media-search-updated", currentValue);
    },
    domainSearch: function (currentValue) {
      if (!currentValue) {
        this.domainHypenateSearch = false;
        this.domainIndustrySearch = "";
      }

      this.$emit("domain-search-updated", currentValue);
    },
    domainHypenateSearch: function (currentValue) {
      if (currentValue) {
        this.domainSearch = true;
      }

      this.$emit("domain-hypenate-updated", currentValue);
    },
    domainIndustrySearch: function (currentValue) {
      if (currentValue !== "") {
        this.domainSearch = true;
      }

      this.$emit("domain-industry-updated", currentValue);
    },
    webSearch: function (currentValue) {
      this.$emit("web-search-updated", currentValue);
    },
  },
  methods: {
    updateSocialMediaTwitterValue() {
      this.socialMediaTwitterSearch = !this.socialMediaTwitterSearch;
      this.socialMediaSearch = true;
      this.$emit("social-media-twitter-updated", this.socialMediaTwitterSearch);
    },

    updateSocialMediaInstagramValue() {
      this.socialMediaInstagramSearch = !this.socialMediaInstagramSearch;
      this.socialMediaSearch = true;
      this.$emit(
        "social-media-instagram-updated",
        this.socialMediaInstagramSearch
      );
    },

    updateSocialMediaFacebookValue() {
      this.socialMediaFacebookSearch = !this.socialMediaFacebookSearch;
      this.socialMediaSearch = true;
      this.$emit(
        "social-media-facebook-updated",
        this.socialMediaFacebookSearch
      );
    },

    toggleAccordion(key) {
      $(this.$refs[key]).prev().toggleClass("accordion__header--open");
      $(this.$refs[key]).slideToggle();
    },
  },
};
</script>
